import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { queryClient } from '@src/services/common';
import * as queries from '@src/services/queries';
import SettingsContainer from '@shared/components/SettingsContainer';
import CriticalEventForm from '@src/features/CriticalEventFormContainer';
import { useDashboardInterval } from '../store';
import type { RecoveryChildrenProps } from '@src/shared/components/Recovery';

export interface EventSettingProps
  extends Partial<RecoveryChildrenProps<GetProp<typeof CriticalEventForm, 'initialValue'>>> {
  id?: string;
}

const EventSetting = (props: EventSettingProps) => {
  const { id, cachedValues, onUpdate, onDispose } = props;
  const interval = useDashboardInterval();
  const navigate = useNavigate();

  const handleDispose = React.useCallback(() => {
    void navigate('.', { replace: true });
    onDispose?.();
  }, [navigate, onDispose]);

  const handleSave = React.useCallback(() => {
    void queryClient.invalidateQueries({
      queryKey: [queries.QUERY_KEY_CRITICAL_EVENTS],
    });
    handleDispose();
  }, [handleDispose]);

  return (
    <SettingsContainer header="Edit Critical Event">
      <CriticalEventForm
        id={id}
        interval={interval}
        initialValue={cachedValues}
        onChange={onUpdate}
        onCancel={handleDispose}
        onSave={handleSave}
      />
    </SettingsContainer>
  );
};

export default EventSetting;
